(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["insta-reel-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('insta-reel-slider')) {
    customElements.define(
      'insta-reel-slider',
      class InstaReelSlider extends HTMLElement {
        constructor() {
          super();
          this.grid = this.querySelector('.insta-reel-slider__grid');
          this.cards = Array.from(this.querySelectorAll('.insta-reel-card'));
          this.prevBtn = this.querySelector('.insta-reel-slider__button--prev');
          this.nextBtn = this.querySelector('.insta-reel-slider__button--next');
          this.dots = Array.from(this.querySelectorAll('.insta-reel-slider__dot'));
          
          this.autoplay = this.dataset.autoplay === 'true';
          this.interval = parseInt(this.dataset.interval, 10) * 1000 || 0;
          this.isMuted = this.dataset.muted === 'true';
          
          this.timer = null;
          this.activeIndex = 0;
          this.isHovered = false;
          this.isUserInteracting = false;
          
          this.init();
        }

        init() {
          if (!this.grid || this.cards.length === 0) return;

          // Pause auto-sliding when user hovers or interacts
          this.addEventListener('mouseenter', () => {
            this.isHovered = true;
            this.stopTimer();
          });

          this.addEventListener('mouseleave', () => {
            this.isHovered = false;
            if (!this.isUserInteracting) {
              this.startTimer();
            }
          });

          // Touch / pointer interaction handling
          this.grid.addEventListener('touchstart', () => {
            this.isUserInteracting = true;
            this.stopTimer();
          }, { passive: true });

          this.grid.addEventListener('touchend', () => {
            this.isUserInteracting = false;
            if (!this.isHovered) {
              this.startTimer();
            }
          }, { passive: true });

          // Navigation buttons
          if (this.prevBtn) {
            this.prevBtn.addEventListener('click', () => {
              this.stopTimer();
              this.slidePrev();
            });
          }

          if (this.nextBtn) {
            this.nextBtn.addEventListener('click', () => {
              this.stopTimer();
              this.slideNext();
            });
          }

          // Pagination Dots
          this.dots.forEach((dot) => {
            dot.addEventListener('click', (e) => {
              this.stopTimer();
              const index = parseInt(e.currentTarget.dataset.index, 10);
              this.scrollToIndex(index);
            });
          });

          // Scroll event listener for updating dots and playing active video
          this.grid.addEventListener('scroll', () => this.handleScroll(), { passive: true });

          // Touch drag swipe state
          this.setupTouchSwipe();

          // Setup video events per card
          this.cards.forEach((card, idx) => {
            this.setupCardVideo(card, idx);
          });

          // Intersection Observer for autoplay when section enters viewport
          this.setupIntersectionObserver();

          // Shopify Theme Editor listener
          if (Shopify && Shopify.designMode) {
            document.addEventListener('shopify:block:select', (e) => {
              const blockId = e.detail.blockId;
              const card = this.querySelector(`[data-shopify-editor-block*="${blockId}"]`) || this.querySelector(`#Slide-${e.detail.sectionId}-${blockId}`);
              if (card) {
                const index = this.cards.indexOf(card);
                if (index !== -1) this.scrollToIndex(index);
              }
            });
          }
        }

        setupTouchSwipe() {
          let isDown = false;
          let startX, scrollLeft;

          this.grid.addEventListener('mousedown', (e) => {
            isDown = true;
            this.isUserInteracting = true;
            this.stopTimer();
            startX = e.pageX - this.grid.offsetLeft;
            scrollLeft = this.grid.scrollLeft;
          });

          this.grid.addEventListener('mouseleave', () => {
            isDown = false;
            this.isUserInteracting = false;
          });

          this.grid.addEventListener('mouseup', () => {
            isDown = false;
            this.isUserInteracting = false;
            if (!this.isHovered) {
              this.startTimer();
            }
          });

          this.grid.addEventListener('mousemove', (e) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - this.grid.offsetLeft;
            const walk = (x - startX) * 1.5;
            this.grid.scrollLeft = scrollLeft - walk;
          });
        }

        setupCardVideo(card, idx) {
          const video = card.querySelector('video');
          const playBtn = card.querySelector('.insta-reel-card__play-btn');
          const soundBtn = card.querySelector('.insta-reel-card__sound-btn');
          const progressFill = card.querySelector('.insta-reel-card__progress-fill');
          const posterOverlay = card.querySelector('.insta-reel-card__poster-overlay');

          // Initialize play button state immediately on load
          if (playBtn) {
            if (!video || video.paused) {
              playBtn.classList.add('is-paused');
              const playIcon = playBtn.querySelector('.icon-play');
              const pauseIcon = playBtn.querySelector('.icon-pause');
              if (playIcon) playIcon.classList.remove('hidden');
              if (pauseIcon) pauseIcon.classList.add('hidden');
            }
          }

          if (video) {
            video.muted = this.isMuted;

            video.addEventListener('play', () => {
              if (posterOverlay) posterOverlay.classList.add('is-hidden');
              if (playBtn) {
                playBtn.classList.remove('is-paused');
                const playIcon = playBtn.querySelector('.icon-play');
                const pauseIcon = playBtn.querySelector('.icon-pause');
                if (playIcon) playIcon.classList.add('hidden');
                if (pauseIcon) pauseIcon.classList.remove('hidden');
              }
            });

            video.addEventListener('pause', () => {
              if (posterOverlay && video.currentTime === 0) {
                posterOverlay.classList.remove('is-hidden');
              }
              if (playBtn) {
                playBtn.classList.add('is-paused');
                const playIcon = playBtn.querySelector('.icon-play');
                const pauseIcon = playBtn.querySelector('.icon-pause');
                if (playIcon) playIcon.classList.remove('hidden');
                if (pauseIcon) pauseIcon.classList.add('hidden');
              }
            });

            // Tap overlay to play/pause
            if (playBtn) {
              playBtn.addEventListener('click', (e) => {
                e.stopPropagation();
                this.stopTimer();
                if (video.paused) {
                  video.play();
                } else {
                  video.pause();
                }
              });
            }

            // Sound Toggle Button
            if (soundBtn) {
              soundBtn.addEventListener('click', (e) => {
                e.stopPropagation();
                this.stopTimer();
                this.isMuted = !this.isMuted;
                this.syncSoundState();
              });
            }

            // Progress bar
            video.addEventListener('timeupdate', () => {
              if (video.duration && progressFill) {
                const percent = (video.currentTime / video.duration) * 100;
                progressFill.style.width = `${percent}%`;
              }
            });

            video.addEventListener('ended', () => {
              if (posterOverlay) posterOverlay.classList.remove('is-hidden');
              if (this.autoplay && this.interval === 0) {
                this.slideNext();
              }
            });
          }
        }

        syncSoundState() {
          this.cards.forEach((card) => {
            const video = card.querySelector('video');
            const soundOff = card.querySelector('.icon-sound-off');
            const soundOn = card.querySelector('.icon-sound-on');

            if (video) video.muted = this.isMuted;
            if (soundOff && soundOn) {
              if (this.isMuted) {
                soundOff.classList.remove('hidden');
                soundOn.classList.add('hidden');
              } else {
                soundOff.classList.add('hidden');
                soundOn.classList.remove('hidden');
              }
            }
          });
        }

        handleScroll() {
          const gridCenter = this.grid.scrollLeft + this.grid.offsetWidth / 2;
          let closestIndex = 0;
          let minDiff = Infinity;

          this.cards.forEach((card, i) => {
            const cardCenter = card.offsetLeft + card.offsetWidth / 2;
            const diff = Math.abs(gridCenter - cardCenter);
            if (diff < minDiff) {
              minDiff = diff;
              closestIndex = i;
            }
          });

          if (closestIndex !== this.activeIndex) {
            this.activeIndex = closestIndex;
            this.updateActiveState();
          }
        }

        updateActiveState() {
          // Toggle active class on card elements & manage video/poster state
          this.cards.forEach((card, i) => {
            const video = card.querySelector('video');
            const posterOverlay = card.querySelector('.insta-reel-card__poster-overlay');
            const playBtn = card.querySelector('.insta-reel-card__play-btn');

            if (i === this.activeIndex) {
              card.classList.add('is-active');
              if (this.autoplay && video) {
                const playPromise = video.play();
                if (playPromise !== undefined) {
                  playPromise
                    .then(() => {
                      if (posterOverlay) posterOverlay.classList.add('is-hidden');
                    })
                    .catch(() => {
                      if (posterOverlay) posterOverlay.classList.remove('is-hidden');
                      if (playBtn) {
                        playBtn.classList.add('is-paused');
                        const playIcon = playBtn.querySelector('.icon-play');
                        const pauseIcon = playBtn.querySelector('.icon-pause');
                        if (playIcon) playIcon.classList.remove('hidden');
                        if (pauseIcon) pauseIcon.classList.add('hidden');
                      }
                    });
                }
              }
            } else {
              card.classList.remove('is-active');
              if (video) {
                video.pause();
                video.currentTime = 0;
              }
              if (posterOverlay) {
                posterOverlay.classList.remove('is-hidden');
              }
              if (playBtn) {
                playBtn.classList.add('is-paused');
                const playIcon = playBtn.querySelector('.icon-play');
                const pauseIcon = playBtn.querySelector('.icon-pause');
                if (playIcon) playIcon.classList.remove('hidden');
                if (pauseIcon) pauseIcon.classList.add('hidden');
              }
            }
          });

          // Update Dots
          this.dots.forEach((dot, i) => {
            if (i === this.activeIndex) {
              dot.classList.add('active');
            } else {
              dot.classList.remove('active');
            }
          });

          this.resetTimer();
        }

        scrollToIndex(index) {
          if (index < 0 || index >= this.cards.length) return;
          const card = this.cards[index];
          if (card) {
            const targetScrollLeft = card.offsetLeft - (this.grid.offsetWidth - card.offsetWidth) / 2;
            this.grid.scrollTo({
              left: Math.max(0, targetScrollLeft),
              behavior: 'smooth',
            });
          }
          this.activeIndex = index;
          this.updateActiveState();
        }

        slidePrev() {
          const newIdx = this.activeIndex > 0 ? this.activeIndex - 1 : this.cards.length - 1;
          this.scrollToIndex(newIdx);
        }

        slideNext() {
          const newIdx = this.activeIndex < this.cards.length - 1 ? this.activeIndex + 1 : 0;
          this.scrollToIndex(newIdx);
        }

        setupIntersectionObserver() {
          const observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  this.updateActiveState();
                  this.startTimer();
                } else {
                  this.pauseAllVideos();
                  this.stopTimer();
                }
              });
            },
            { threshold: 0.4 }
          );
          observer.observe(this);
        }

        pauseAllVideos() {
          this.cards.forEach((card) => {
            const video = card.querySelector('video');
            if (video) video.pause();
          });
        }

        startTimer() {
          if (this.interval > 0 && !this.timer && !this.isHovered && !this.isUserInteracting) {
            this.timer = setInterval(() => {
              this.slideNext();
            }, this.interval);
          }
        }

        stopTimer() {
          if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
          }
        }

        resetTimer() {
          this.stopTimer();
          if (!this.isHovered && !this.isUserInteracting) {
            this.startTimer();
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
